import React, {Component} from "react";
import {Container} from "reactstrap";
import SectionTitle from "../../components/Shared/SectionTitle";

//Import Icons
import Feature from "../../components/Shared/Feature";
import pen from "../../assets/images/icon/pen.svg";
import video from "../../assets/images/icon/video.svg";
import intellectual from "../../assets/images/icon/intellectual.svg";
import user from "../../assets/images/icon/user.svg";
import calendar from "../../assets/images/icon/calendar.svg";
import sandClock from "../../assets/images/icon/sand-clock.svg";

export default class Features extends Component {
  constructor(props) {
    super(props);
    this.state = {
      features: [
        {
          id: 1,
          icon: 'uil uil-edit-alt h1 text-primary',
          imgUrl: pen,
          title: "GOLD & SILVER REFINERY",
          description:
            "We offer high quality refinery services that ensure that the best product is put out to the market",
        },
        {
          id: 2,
          icon: 'uil uil-vector-square h1 text-primary',
          imgUrl: video,
          title: "SMELTING",
          description:
            "We use environmentally friendly practices to convert large lots of gold and silver into smaller quantities as per the clients request.",
        },
        {
          id: 3,
          icon: 'uil uil-file-search-alt h1 text-primary',
          imgUrl: intellectual,
          title: "ASSAYING SERVICES",
          description:
            "We are among a very small group of companies that offer assaying services, specializing in Cupellation Method, to determine the concentration of Gold.",
        },
        {
          id: 4,
          icon: 'uil uil-airplay h1 text-primary',
          imgUrl: user,
          title: "RARE MINERAL SALES",
          description:
            "We facilitate sales of rare minerals that have undergone thorough inspection, validation and refinery to our large clientele.",
        },
        {
          id: 5,
          icon: 'uil uil-calendar-alt h1 text-primary',
          imgUrl: calendar,
          title: "MINERAL SEPARATION SERVICES",
          description:
            "We offer unparalleled rare minerals separation and recovery services with utmost transparency and precision.",
        },
        {
          id: 6,
          icon: 'uil uil-clock h1 text-primary',
          imgUrl: sandClock,
          title: "MINTING",
          description:
            "We offer modern minting services producing customized medallions, coins, medals and bullions for a wide range of clients.",
        },
      ],
    };
  }
  render() {
    return (
      <React.Fragment>
          <Container className={""}>
            <SectionTitle
              title="What We Do"
              desc="Learn about the wide range of metal services we offer, from Gold & Silver Refinery to specialized minting and mineral separation services. Our experienced team is ready to bring your metal projects to life with precision and quality."
            />
             <Feature featureArray={this.state.features} isCenter={true} />
          </Container>
      </React.Fragment>
    );
  }
}
